export enum TransactionTypeEnum {
  sale = 'dashboard.transactions.sale',
  refund = 'dashboard.transactions.refund',
}
